export default "__VITE_ASSET__DFZa1tDz__"